import { Alert, Snackbar } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { clearError } from '../store/slices/authSlice';

function ErrorAlert() {
  const dispatch = useDispatch();
  const error = useSelector(state => state.auth.error);

  const handleClose = () => {
    dispatch(clearError());
  };

  return (
    <Snackbar
      open={!!error}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity="error" variant="filled">
        {error}
      </Alert>
    </Snackbar>
  );
}

export default ErrorAlert; 